<template>
  <div class="modal fade" id="myAgreementModal" tabindex="-1" aria-labelledby="myAgreementModalLabel" @keydown.esc="clearForm(false)">
    <div class="modal-dialog modal-lg">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header p-5">
          <h5 class="modal-title">{{ agreement.title }}</h5>
          <button type="button" @click="clearForm(false)" class="btn-close"></button>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div class="col-lg-8">
              <object
                  :data="agreement.document+'#view=Fit'"
                  class="mb-5"
                  type="application/pdf"
                  width="100%"
                  style="height: 40vh"
              />
            </div>
            <div class="col-lg-4">
              <div v-if="error" class="alert alert-danger d-flex align-items-center p-5">
                <div class="d-flex flex-column">
                  <span v-html="error"></span>
                </div>
              </div>
              <div v-if="step === 0">
                <div @click="sendOtp(agreement.id)" class="btn btn-xs btn-primary d-block">Согласовать</div>
              </div>
              <div v-if="step > 0">
                <div class="alert alert-primary p-5 text-center">
                  <span>Код отправлено по номеру <br> <b>{{ this.phone }}</b></span>
                </div>
                <input-mask-field
                    v-model="this.code"
                    id="form.code"
                    name="form_code"
                    :required="true"
                    :mb="5"
                    placeholder="Код"
                    mask="####"
                    type="text"
                />
                <button v-if="step === 1" class="btn btn-xs btn-warning btn-block" :disabled="this.timer !== 0" @click="sendOtp(agreement.id)">
                  <span class="indicator-label">Повторно отправить код <br>
                    <span v-if="this.timer > 0"> через {{ this.timer }} сек.</span>
                  </span>
                </button>
                <button v-if="step === 2" class="btn btn-xs btn-primary btn-block" @click="checkCode(agreement.id)">
                  <span class="indicator-label">Подтвердить код</span>
                </button>
              </div>
            </div>
            <div class="col-lg-12">
              <p>{{ agreement.description }}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer p-3 justify-content-center">
          <button @click="clearForm(false)" class="btn btn-sm btn-light-warning" type="button">Закрыть</button>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderFull     from '@/components/Main/LoaderFull'
import InputMaskField from '@/components/Fields/InputMaskField';
import axios from "axios";
import agreement from "@/views/Admin/Agreement/Agreement.vue";

export default {
  name: 'MyAgreementsModal',
  components: {InputMaskField, LoaderFull },
  props: {
    agreement: {
      type: Object,
      required: true
    }
  },
  mounted() {
    setTimeout(() => {
      document.getElementById('myAgreementModal').addEventListener('mousedown', (event) => {
        if (event.target.classList.contains('modal')) this.clearForm(false)
      });
    }, 10)
    if (agreement) this.check()
  },
  data() {
    return {
      loader:   false,
      step:     0,
      code:     '',
      interval: null,
      error:    null,
      timer:    0,
      phone:    null,
    }
  },
  methods: {
    clearForm(isUpdateList) {
      this.$emit('close', {update: isUpdateList})
    },
    countDownTimer() {
      this.interval = setInterval(() => {
        if (this.timer === 0) {
          clearInterval(this.interval)
          this.timer = 0
        } else {
          this.timer = this.timer - 1
        }
      }, 1000)
    },
    sendOtp(id) {
      this.loader = true
      axios.get('/api/agreement/my-agreement-send-otp/'+id)
          .then(res => {
            if (res.data.result) {
              this.timer = 300
              this.countDownTimer()
              this.step = 1
              this.phone = res.data.sendPhone
            } else {
              this.error = res.data.message
            }
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.loader = false
          })
    },
    check() {axios.get('/api/agreement/my-agreement-check/'+this.agreement.id)},
    checkCode(id) {
      this.loader = true
      axios.post('/api/agreement/my-agreement-check/verify', {id: id, code: this.code})
          .then(res => {
            if (res.data.result) {
              this.clearForm(true)
            } else {
              this.error = res.data.message
              this.code = ''
            }
          })
          .catch(err => {
            this.step = 0
            this.error = err.message
          })
          .finally(() => {
            this.loader = false
          })
    },
  },
  watch: {
    code: {
      immediate: true,
      handler(val) {
        if (this.step > 0) this.step = val.length > 3 ? 2 : 1
      }
    }
  }
}
</script>

<style scoped>

</style>